import { useState } from "react";
import {
  AppShell,
  Navbar,
  Header,
  Footer,
  Text,
  MediaQuery,
  Burger,
  useMantineTheme,
  Button,
  Tooltip,
  Image,
  ScrollArea,
} from "@mantine/core";

import { Route, Routes, useNavigate } from "react-router-dom";

import { withAuthenticator } from "@aws-amplify/ui-react";

import { Logout, Home2, Notes, ArrowBack, Settings } from "tabler-icons-react";
import HomePage from "./HomePage";
import { SelectedContext } from "../Contexts/SelectedContext";
import SelectedCampaign from "./SelectedCampaign";
import { motion } from "framer-motion";
import { ActionToggle } from "./DarkLight/ActionToggle";
import { invalidParameter } from "@aws-amplify/core";
import ActiveCampaigns from "./ActiveCampaigns";
import SettingsPage from "./SettingsPage";

function MainPage({ user, signOut }) {
  const Navigate = useNavigate();

  const imageColor = localStorage.getItem("ColorScheme");

  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  // const [currentPage, setCurrentPage] = useState(<HomePage />);
  const [selected, setSelected] = useState(true);
  return (
    <SelectedContext.Provider value={{ selected, setSelected }}>
      <>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[8]
                  : theme.colors.gray[0],
            },
          }}
          padding="md"
          navbarOffsetBreakpoint="sm"
          asideOffsetBreakpoint="sm"
          navbar={
            <Navbar
              p="sm"
              hiddenBreakpoint="sm"
              hidden={!opened}
              width={{ sm: 70, lg: 70 }}
              style={{ boxShadow: "rgb(22 22 22 / 9%) 0px 5px 10px" }}
            >
              <Navbar.Section
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexFlow: "column",
                }}
                grow
              >
                <Tooltip label="Home" position="right">
                  <Button
                    variant="default"
                    mt={5}
                    radius="lg"
                    color="black"
                    onClick={() => {
                      setSelected("");
                      setOpened(false);
                      Navigate("/dashboard");
                    }}
                    style={{
                      display: "flex",
                      height: "50px",
                      width: "50px",
                      justifyContent: "center",
                      border: "0",
                    }}
                  >
                    <Home2 size={30} />
                  </Button>
                </Tooltip>
                <Tooltip label="Sponsorships" position="right">
                  <Button
                    mt={15}
                    variant="default"
                    radius="lg"
                    color="black"
                    onClick={() => {
                      setOpened(false);
                      Navigate("/sponsorships");
                    }}
                    style={{
                      display: "flex",
                      height: "50px",
                      width: "50px",
                      justifyContent: "center",
                      border: "0",
                    }}
                  >
                    <Notes size={30} />
                  </Button>
                </Tooltip>
              </Navbar.Section>

              <Navbar.Section
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexFlow: "column wrap",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <Tooltip position="right" label="Settings">
                  <Button
                    variant="default"
                    radius="lg"
                    onClick={() => {
                      setOpened(false);
                      Navigate("/settings");
                    }}
                    style={{
                      border: "0",
                      display: "flex",
                      height: "50px",
                      width: "50px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Settings />
                  </Button>
                </Tooltip>
                <ActionToggle />
                <Tooltip position="right" label="Logout">
                  <Button
                    variant="default"
                    radius="lg"
                    onClick={() => signOut()}
                    style={{
                      border: "0",
                      display: "flex",
                      height: "50px",
                      width: "50px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Logout />
                  </Button>
                </Tooltip>
                <MediaQuery
                  query="(min-width:768px)"
                  styles={{ display: "none" }}
                >
                  <div style={{ width: "50px", height: "50px" }}></div>
                </MediaQuery>
              </Navbar.Section>
            </Navbar>
          }
          header={
            <Header
              height={70}
              p="md"
              style={{ boxShadow: "rgb(22 22 22 / 9%) 0px 5px 5px" }}
            >
              <MediaQuery
                query="(min-width:768px)"
                styles={{
                  justifyContent: "space-between",
                  marginRight: "50px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                    <Burger
                      opened={opened}
                      onClick={() => setOpened((o) => !o)}
                      size="sm"
                      color={theme.colors.gray[6]}
                      mr="xl"
                    />
                  </MediaQuery>
                  <MediaQuery
                    query="(min-width: 768px)"
                    styles={{ paddingLeft: "60px" }}
                  >
                    <motion.div
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => {
                        Navigate("/");
                      }}
                    >
                      <Image
                        style={{
                          filter: imageColor === "dark" ? "invert(100%)" : "",
                        }}
                        fit="contain"
                        height={25}
                        src="https://adly-campaigns.s3.eu-north-1.amazonaws.com/ADLY_LOGO_2022_BLACK.png"
                      ></Image>
                      <div style={{ marginLeft: "5px", whiteSpace: "nowrap" }}>
                        <Text
                          style={{ fontFamily: "'Segoe UI', sans-serif" }}
                          color="dimmed"
                          weight={500}
                          size="min(4vw, 1.1em)"
                        >
                          Streamer Platform
                        </Text>
                      </div>
                    </motion.div>
                  </MediaQuery>
                  <MediaQuery
                    query="(max-width: 768px)"
                    styles={{ display: "none" }}
                  >
                    <div>
                      <div style={{ display: "flex" }}>
                        <Text style={{ opacity: "0.5" }}>Welcome, &nbsp;</Text>
                        <Text style={{ opacity: "0.8" }} weight={400}>
                          {user.attributes.email}
                        </Text>
                      </div>
                    </div>
                  </MediaQuery>
                </div>
              </MediaQuery>
            </Header>
          }
        >
          <div style={{ width: "100%" }}>
            <MediaQuery
              query="(min-width: 768px)"
              styles={{ marginLeft: "2vw", marginTop: "2vw" }}
            >
              <div>
                <Routes>
                  <Route path="" element={<HomePage />} />
                  <Route path="/dashboard" element={<HomePage />} />
                  <Route path="/sponsorships" element={<ActiveCampaigns />} />
                  <Route path="/settings" element={<SettingsPage />} />
                </Routes>
              </div>
            </MediaQuery>
          </div>
        </AppShell>
      </>
    </SelectedContext.Provider>
  );
}

export default withAuthenticator(MainPage);
